import React, { ReactNode } from 'react';

interface Props {
    className: string;
    children: ReactNode;
    handleEvent: () => void
}

const Button: React.FC<Props> = ({
    className,
    children,
    handleEvent
}) => {
    return (
        <button type="button" className={className} onClick={handleEvent}>{children}</button>
    )
}

export default Button;